import { Body, Equator, Horizon, Illumination, MoonPhase, Observer } from "astronomy-engine";

export interface CelestialState {
  sun: {
    visible: boolean;
    altitudeDeg: number;
    azimuthDeg: number;
    direction: [number, number, number];
  };
  moon: {
    visible: boolean;
    altitudeDeg: number;
    azimuthDeg: number;
    direction: [number, number, number];
    phaseDeg: number;
    illuminatedFraction: number;
  };
}

const observer = new Observer(40.7831, -73.9712, 10);
function horizontal(
  body: Body,
  date: Date,
): {
  visible: boolean;
  altitudeDeg: number;
  azimuthDeg: number;
  direction: [number, number, number];
} {
  const equatorial = Equator(body, date, observer, true, true);
  const horizon = Horizon(date, observer, equatorial.ra, equatorial.dec, "normal");
  const altitude = (horizon.altitude * Math.PI) / 180;
  const azimuth = (horizon.azimuth * Math.PI) / 180;
  return {
    visible: horizon.altitude >= 0,
    altitudeDeg: horizon.altitude,
    azimuthDeg: horizon.azimuth,
    direction: [
      Math.cos(altitude) * Math.sin(azimuth),
      Math.sin(altitude),
      -Math.cos(altitude) * Math.cos(azimuth),
    ],
  };
}

export class AstronomyService {
  stateAt(date: Date): CelestialState {
    return {
      sun: horizontal(Body.Sun, date),
      moon: {
        ...horizontal(Body.Moon, date),
        phaseDeg: MoonPhase(date),
        illuminatedFraction: Illumination(Body.Moon, date).phase_fraction,
      },
    };
  }
}
